import axios from 'axios';

const getCotacoes = (params) => axios.get('/cotacoes/all', {
  params,
});

export default {
  getCotacoes,
};
